import React from 'react';
import __ from 'lodash';
 
class DropdownPtn extends React.Component{
    render(){
        return (
            this.props.ptn.map((val) =>
                <option key={val.idPtn} value={val.idPtn}>{val.namaPtn}</option>
            )            
        )
    }
}

export default DropdownPtn;